export default "__VITE_ASSET__jGOD5vRi__"